module.exports = {
  WHEEL_THROTTLE_TIME: 400,
}
